import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as climateData from '../../assets/climats.json'
import {Climates} from "./climate.model";
import {ClientList} from "../listclients/listclientsdata";
import {UrlBuilder} from "../url-builder/url.builder";
import {envelopIcon} from "@progress/kendo-svg-icons";
import {environment} from "../../environments/environment";



@Injectable({
  providedIn: 'root'
})
export class ClientDataServiceService {



  constructor(private http: HttpClient) {}

  getClimatsJSON(): Observable<Climates> {
    if(environment.useDummyData)
      return this.getDummyClimatsJSON();
    else
      return this.getLiveClimatsJSON();
  }

  getLiveClimatsJSON(): Observable<Climates> {
    var url = new UrlBuilder();
    return this.http.get<Climates>(url.GetClimateListUrl());
  }

    getDummyClimatsJSON(): Observable<Climates> {
        return new Observable(observer => {
            observer.next(climateData);
            observer.complete();
        });
    }


}

